import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import DropLocation from 'components/DragAndDrop/DropLocation/DropLocation'
import strings from 'utils/strings'
import DraggablePart from 'components/SwitchAndGauge/DashDrawer/DraggableList/DraggablePart/DraggablePart'
import {
  Group,
  SectionHeader,
  StyledCollapsibleWidget,
  ShowDetailsButton,
} from 'components/SwitchAndGauge/DashDrawer/DraggableList/DraggablePartListView.style'

const CollapsibleList = ({
  id,
  label,
  slots,
  showCollapsibleTitle,
  canDragGroup,
  viewDetail,
  onClickViewDetail,
}) => {
  const handleShowDetails = (event) => {
    onClickViewDetail(!viewDetail)
    event.stopPropagation()
  }

  const draggable = showCollapsibleTitle && canDragGroup

  return (
    <Group key={`${id}-${label}-group`}>
      {draggable ? (
        <DropLocation location={id}>
          <StyledDraggableGroup>
            <DraggablePart location={id} className="draggable-group">
              <StyledCollapsibleWidget
                collapsed={false}
                title={
                  <>
                    <SectionHeader
                      key={label}
                      size="small"
                      weight="bold"
                      data-testid="section-header"
                    >
                      {label}
                    </SectionHeader>
                    {slots.length > 0 && (
                      <ShowDetailsButton onClick={handleShowDetails} link>
                        {viewDetail
                          ? strings.hide_details
                          : strings.show_details}
                      </ShowDetailsButton>
                    )}
                  </>
                }
              >
                {slots}
              </StyledCollapsibleWidget>
            </DraggablePart>
          </StyledDraggableGroup>
        </DropLocation>
      ) : (
        <StyledCollapsibleWidget
          collapsed={false}
          title={
            <>
              <SectionHeader
                key={label}
                size="small"
                weight="bold"
                data-testid="section-header"
              >
                {label}
              </SectionHeader>
              {slots.length > 0 && (
                <ShowDetailsButton onClick={handleShowDetails} link>
                  {viewDetail ? strings.hide_details : strings.show_details}
                </ShowDetailsButton>
              )}
            </>
          }
        >
          {slots}
        </StyledCollapsibleWidget>
      )}
    </Group>
  )
}

CollapsibleList.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  slots: PropTypes.array,
  showCollapsibleTitle: PropTypes.bool,
  canDragGroup: PropTypes.bool,
  viewDetail: PropTypes.bool,
  onClickViewDetail: PropTypes.func,
}

export default CollapsibleList

const StyledDraggableGroup = styled.div`
  position: relative;

  .draggable-group.drag-item-handle {
    position: absolute;
    top: -2px;
    left: 0;
  }

  .collapsible-widget_header {
    padding-left: 20px;
  }
`
